<template>
  <teleport :to="selector">
    <!-- aria attributes will be revisited with the other accessibility issue -->
    <dialog
      :id="id"
      ref="dialog"
      class="ui-dialog nextgen-dialog"
      :aria-describedby="'dialog-content-' + uuid"
      :aria-labelledby="'dialog-title-' + uuid"
      @close="$emit('close')">
      <div class="ui-dialog-titlebar ui-widget-header ui-helper-clearfix">
        <span
          :id="'dialog-title-' + uuid"
          class="ui-dialog-title"
          >{{ title }}</span
        >
        <button
          :id="`${id}-dialog-box-close-button`"
          class="button ui-dialog-close"
          @click.prevent="closeDialog()">
          <svgicon
            original
            data="@iconPath/glyph/12/close.svg?inline"
            width="10"
            height="10"></svgicon>
        </button>
      </div>
      <div
        :id="'dialog-content-' + uuid"
        class="ui-dialog-content ui-widget-content">
        <slot></slot>
      </div>
      <div
        v-if="hasButtonPane"
        class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
        <div class="ui-dialog-buttonset">
          <slot name="buttons"></slot>
        </div>
      </div>
    </dialog>
  </teleport>
</template>

<script>
let uuid = 0

export default {
  name: 'DialogComponent',
  emits: ['close'],
  props: {
    id: String,
    title: String,
    selector: String,
    hasButtonPane: Boolean
  },
  data() {
    return {
      uuid: 0
    }
  },
  created() {
    uuid++
    this.uuid = uuid
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.dialog.showModal()
    })
  },
  methods: {
    closeDialog() {
      this.$refs.dialog.close()
      this.$emit('close')
    }
  }
}
</script>

<style lang="less">
@import '../assets/css/abstract/variables.less';
@import '../assets/css/abstract/mixins.less';

.nextgen-dialog {
  min-width: 200px;
  min-height: 100px;
  max-width: calc(100% - 20px);
  max-height: calc(100% - 20px);
  position: relative;

  .ui-dialog-titlebar {
    display: flex;
    justify-content: flex-end;
    background-color: @gray-color;
    border-bottom: 1px solid hsla(0, 0%, 75%, 0.5);

    .ui-dialog-title {
      width: 100%;
      margin: 0;
    }

    .ui-dialog-close {
      .default-focus-indicator(-2px, @primary-color);
      margin: 0px;
    }
  }

  &::backdrop {
    background: rgba(0, 0, 0, 0.2);
  }
}
</style>
